import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";

import { TabsPlugin, BCard, BCardText } from "bootstrap-vue";

import { quotesMenuMixin } from "./vue/mixins/quotes";
import QuoteSearch from "./vue/components/quote-search/QuoteSearch.vue";

const mixins = [];
mixins.push(quotesMenuMixin);
initMain(
  mixins,
  {
    QuoteSearch,
    DolarSpotGraph: () =>
      import("./vue/components/dolar-spot-graph/DolarSpotGraph.vue"),
    QuoteGraph: () => import("./vue/components/quote-graph/QuoteGraph.vue"),
    RecentQuotes: () =>
      import("./vue/components/recent-quotes/RecentQuotes.vue"),
    IpcGraph: () => import("./vue/components/ipc-graph/IpcGraph.vue"),
    BCard,
    BCardText,
  },
  [TabsPlugin]
);
header();
